var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-template',{attrs:{"title":"Marcas Parceiras"}},[_c('grid-list',{staticClass:"mt-4",attrs:{"col-width":"200px"}},[(_vm.brands.length)?_vm._l((_vm.brands),function(ref,i){
var img = ref.img;
var title = ref.title;
var to = ref.to;
return _c('brand-card',{key:i,attrs:{"img":img,"title":title,"to":to}})}):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }